import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';

const styles = makeStyles(() => ({
  icon: {
    fontSize: 12,
  },
  iconWarning: {
    color: amber[700],
    fontSize: 12,
  },
  iconSuccess: {
    color: green[600],
    fontSize: 12,
  },
}));

const EventProfitability = props => {
  const { profit, eventName } = props;
  const profitDecimal = parseFloat(profit);
  const classes = styles();

  if (profitDecimal < 0.33) {
    return (
      <Icon className={classes.icon} color="error">
        {eventName}
      </Icon>
    );
  }
  if (profitDecimal < 0.67) {
    return <Icon className={classes.iconWarning}>{eventName}</Icon>;
  }
  if (profitDecimal > 0.67) {
    return <Icon className={classes.iconSuccess}>{eventName}</Icon>;
  }
  return <div>{eventName}</div>;
};

export const EventNameRenderer = ({ value, data }) => {
  return <EventProfitability profit={data.event_profitability} eventName={value} />;
};

EventNameRenderer.propTypes = {
  value: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

EventProfitability.propTypes = {
  eventName: PropTypes.string.isRequired,
  profit: PropTypes.string.isRequired,
};

export default EventProfitability;
